import ProductDescription from './ProductDescription'

const BSCornTortillaProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '007BS',
  IsBroadband: true,
  Size: '',
}

export default BSCornTortillaProduct
